function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_30812",
  "data-name": "Group 30812"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5226",
  "data-name": "Rectangle 5226",
  width: 24,
  height: 24,
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5227",
  "data-name": "Rectangle 5227",
  width: 24,
  height: 24,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_30814",
  "data-name": "Group 30814"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_30813",
  "data-name": "Group 30813"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_59692",
  "data-name": "Path 59692",
  d: "M6,4.01a9.966,9.966,0,0,0-3.11,12.1L6,14.31Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59693",
  "data-name": "Path 59693",
  d: "M11,11.42V2.05a9.985,9.985,0,0,0-3,.79V13.16Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59694",
  "data-name": "Path 59694",
  d: "M12,13.15,3.89,17.83a9.891,9.891,0,0,0,2.18,2.2L15,14.89Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59695",
  "data-name": "Path 59695",
  d: "M13,7.96v3.46l8.11,4.68a9.977,9.977,0,0,0,.82-2.98Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59696",
  "data-name": "Path 59696",
  d: "M8.07,21.2a10,10,0,0,0,12.04-3.36L17,16.04Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59697",
  "data-name": "Path 59697",
  d: "M21.92,10.81A10,10,0,0,0,13,2.05v3.6Z"
})));

function SvgSportsVolleyball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sports_volleyball_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsVolleyball);
export default __webpack_public_path__ + "static/media/sports_volleyball.01a787e3.svg";
export { ForwardRef as ReactComponent };